import { useComputed } from '@preact/signals'
import { clsx } from 'clsx'
import { useCallback } from 'preact/hooks'

import { AlertIcon } from 'components/UI/atoms'
import { Modal } from 'components/UI/molecules'
import { resetSystemNotification, systemNotification } from 'state'

const variantsConfig = {
	error: {
		acceptBtnColor: 'bg-error',
		iconHidden: false
	},
	warning: {
		acceptBtnColor: 'bg-warning',
		iconHidden: false
	},
	success: {
		acceptBtnColor: 'bg-product',
		iconHidden: true
	},
	info: {
		acceptBtnColor: '',
		iconHidden: false
	},
	default: {
		acceptBtnColor: '',
		iconHidden: false
	}
}

// TODO: Temporal hanadle onCloseModal and onAccept. Just for testing
const MessageDialog = () => {
	const handleCloseModal = useCallback(() => {
		if (systemNotification.peek().onCloseCallback) {
			systemNotification.peek().onCloseCallback!()
		}

		resetSystemNotification()
	}, [])

	const config = useComputed(() => {
		const { variant = 'default' } = systemNotification.value
		const variantConfig = variantsConfig[variant]

		return {
			visible: systemNotification.value.display === 'dialog',
			...variantConfig
		}
	})

	return (
		<Modal
			className='border border-black-600'
			isOpen={config.value.visible}
			onCloseModal={handleCloseModal}
		>
			<div class='mb-10 flex flex-col items-center px-10 pt-10'>
				<AlertIcon
					className={clsx('text-warning', config.value.iconHidden && 'hidden')}
				/>

				<h2 class='font-madefor mt-6 text-center text-3xl font-bold text-black-100'>
					{systemNotification.value.error?.message}
					{systemNotification.value?.title}
				</h2>
				{systemNotification.value?.message && (
					<p class='mt-6 text-center font-inter text-sm font-normal text-black-200'>
						{systemNotification.value?.message}
					</p>
				)}

				<button
					aria-label='accept'
					class={clsx('mt-10 rounded px-4 py-2.5', config.value.acceptBtnColor)}
					onClick={handleCloseModal}
					type='button'
				>
					<span class='font-inter text-sm font-semibold text-black-900'>
						{systemNotification.value.acceptText ?? 'OK'}
					</span>
				</button>
			</div>
		</Modal>
	)
}

export { MessageDialog }
